import { Bed, PlusCircle, PushPin, Sun } from 'components/shared/Icon/phosphorIcons';
import { SCHEDULE_ITEM_TYPES } from 'utils/itineraryDetails/constants';

import { IScheduleCreateAction } from './types';

export const addScheduleActions: IScheduleCreateAction[] = [
  {
    title: 'Accommodation',
    type: SCHEDULE_ITEM_TYPES.OVERNIGHT,
    icon: Bed,
    onClick: () => {},
  },
  {
    title: 'Activity',
    type: SCHEDULE_ITEM_TYPES.ACTIVITY,
    icon: PushPin,
    onClick: () => {},
  },
  {
    title: 'Dayroom',
    type: SCHEDULE_ITEM_TYPES.DAY_ROOM,
    icon: Sun,
    onClick: () => {},
  },
];

export const mergeSchedulesAction: IScheduleCreateAction = {
  title: 'Insert Itinerary',
  type: SCHEDULE_ITEM_TYPES.INSERT_ITINERARY,
  icon: PlusCircle,
  onClick: () => {},
};
